import { Navigate, Outlet } from 'react-router'
import { ROUTES } from '@/shared/routes'
import { useAuth } from './useAuth'

export const PublicRoute = () => {
  const { isAuthenticated } = useAuth()

  if (isAuthenticated) return <Navigate to={ROUTES.HOME} replace />
  return <Outlet />
}
